
import { Create, Divider, Form, Input, SaveButton, useFileUploadState, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useGetIdentity } from "@pankod/refine-core";
import {
  BackgroundScreeningFormFields,
  DocumentUploadSection,
  useCountryLocationData
} from "components/backgroundscreening/backgroundScreeningForm";
import { CancelButton } from "components/utils/cancelButton";
import { IBackgroundScreening, IUser } from "interfaces";
import { useRef } from "react";
import { DATAPROVIDER_CREATE, getGUID } from "scripts/site";

export const BackgroundScreeningCreate: React.FC<IResourceComponentsProps> = () => {
  const { data: userData } = useGetIdentity();
  const userObj = userData as IUser;

  // Initialize form with refine's useForm hook for managing BackgroundScreeningCreate Component creation
  const { formProps, saveButtonProps, form } = useForm<IBackgroundScreening>({
    dataProviderName: DATAPROVIDER_CREATE,
    redirect: "list",
  });

  // useRef to ensure GUID generated once per component mount
  const guidRef = useRef<string>(getGUID());
  const initialValues = {
    id: guidRef.current,
    managerUserId: userObj?.id,
    comments: "Background Screening request submitted.",
    hasTcsEmployeeId: true,
  };

  // Fetch BackgroundScreeningCreate Component metadata configuration which includes field definitions and validation rules
  // useOne<IScreeningMetadata>({
  //   dataProviderName: DATAPROVIDER_LOOKUP,
  //   resource: RESOURCE_PATH.METADATA,
  //   id: RESOURCE_PATH.BACKGROUND_SCREENING,
  //   queryOptions: {
  //     enabled: true,
  //     staleTime: STALE_DURATION,
  //   },
  // });

  // Get country and location data using shared hook
  const { countryProps, locations } = useCountryLocationData();

  const { onChange: onUploadChange, isLoading: isUploading } = useFileUploadState();

  return (
    <Create
      title="Background Screening Request"
      saveButtonProps={saveButtonProps}
      footerButtons={() => (
        <>
          <SaveButton {...saveButtonProps} loading={isUploading}>Submit</SaveButton>
          <CancelButton />
        </>
      )}
    >
      <Form
        {...formProps}
        autoComplete="off"
        layout="vertical"
        initialValues={initialValues}
      >
        {/* Hidden id field to save GUID */}
        <Form.Item name="id" hidden={true}>
          <Input />
        </Form.Item>

        {/* Shared form fields component */}
        <BackgroundScreeningFormFields
          form={form}
          countryProps={countryProps}
          locations={locations || []}
          onUploadChange={onUploadChange}
        />

        <Divider orientation="left">Document Uploads</Divider>

        <Form.Item name="comments" hidden={true}>
          <Input />
        </Form.Item>

        {/* Shared document upload section, pass id for file uploads */}
        <DocumentUploadSection onUploadChange={onUploadChange} id={initialValues.id} required={true} />
      </Form>
    </Create>
  );
};
